<template>
	<div id="subscription" class="subscription">
		<div v-if="totals">
			<div v-if="!loadingTotals">
				Numero de Suscripciones: <label>{{ totals.total }}</label>
				<i class="fas fa-sync-alt float-right pointer" @click="getAll"></i>
				<div class="progress">
					<div class="progress-bar bg-success" role="progressbar"
						:style="'width: ' + totalPaidPercentage + '%'" aria-valuenow="15" aria-valuemin="0"
						aria-valuemax="100">{{ totalPaidPercentage }}% ({{ totals.confirmed }})</div>
					<div class="progress-bar bg-secondary" role="progressbar"
						:style="'width: ' + (100 - totalPaidPercentage) + '%'" aria-valuenow="30" aria-valuemin="0"
						aria-valuemax="100">{{ (100 - totalPaidPercentage) }}% ({{ totals.total - totals.confirmed }})
					</div>
				</div>
			</div>
			<div v-else>
				<div class="spinner-border spinner-border-sm" role="status">
					<span class="sr-only">cargando...</span>
				</div>
				cargando...
			</div>
			<hr>

			<div class="row">
				<div class="col-lg-3 col-12">
					<!-- small box -->
					<div class="small-box bg-primary">
						<div class="inner pointer" v-if="!loadingTotals" @click="setOnlyPaid(-1)">
							<h3 style="font-weight: normal;">${{ methodFormatNumber(totalsSubscription.created.total +
								totalsSubscription.confirm.total) }}</h3>
							<p class="text-white">de {{ totalsSubscription.created.quantity +
								totalsSubscription.confirm.quantity }} suscripciones ingresadas</p>
						</div>
						<div v-else class="inner">
							<h4 style="font-weight: normal;">
								<div class="spinner-border" role="status">
									<span class="sr-only">cargando...</span>
								</div>
								cargando...
							</h4>
						</div>
						<div class="icon">
							<i class="ion ion-bag"></i>
						</div>
						<router-link to="/subscriptions" class="small-box-footer" title="Suscripciones">Más información
							<i class="fas fa-arrow-circle-right"></i></router-link>
					</div>
				</div>
				<div class="col-lg-3 col-12">
					<!-- small box -->
					<div class="small-box bg-success">
						<div class="inner pointer" v-if="!loadingTotals" @click="setOnlyPaid(31)">
							<h3 style="font-weight: normal;">$ {{ methodFormatNumber(totalsSubscription.confirm.total)
								}}

							</h3>
							<p class="text-white">Confirmadas ({{ totals.confirmed }} - {{ totalPaidPercentage }}%)</p>
						</div>
						<div v-else class="inner">
							<h4 style="font-weight: normal;">
								<div class="spinner-border" role="status">
									<span class="sr-only">cargando...</span>
								</div>
								cargando...
							</h4>
						</div>
						<div class="icon">
							<i class="ion ion-cash"></i>
						</div>
						<a href="#" class="small-box-footer">Más información <i
								class="fas fa-arrow-circle-right"></i></a>
					</div>
				</div>
				<div class="col-lg-3 col-12">
					<!-- small box -->
					<div class="small-box bg-warning">
						<div class="inner" v-if="!loadingTotals">
							<h3 style="font-weight: normal;">${{
								methodFormatNumber(totalsSubscriptionPotentials.created.total +
									totalsSubscriptionPotentials.confirm.total) }}</h3>
							<p>{{ totalsSubscriptionPotentials.created.quantity +
								totalsSubscriptionPotentials.confirm.quantity }} suscripciones estimadas</p>
						</div>
						<div v-else class="inner">
							<h4 style="font-weight: normal;">
								<div class="spinner-border" role="status">
									<span class="sr-only">cargando...</span>
								</div>
								cargando...
							</h4>
						</div>
						<div class="icon">
							<i class="ion ion-home"></i>
						</div>
						<a href="#" class="small-box-footer">Más información <i
								class="fas fa-arrow-circle-right"></i></a>
					</div>
				</div>
				<div class="col-lg-3 col-12">
					<div class="small-box bg-danger">
						<div class="inner" v-if="!loadingTotals">
							<h3 style="font-weight: normal;">${{ methodFormatNumber(totals.paymentAmount) }}</h3>
							<p class="text-white">Pagos confirmados</p>
						</div>
						<div v-else class="inner">
							<h4 style="font-weight: normal;">
								<div class="spinner-border" role="status">
									<span class="sr-only">cargando...</span>
								</div>
								cargando...
							</h4>
						</div>
						<div class="icon">
							<i class="ion ion-pie-graph"></i>
						</div>
						<a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-md-6 col-12">
					<div class="card">
						<div class="card-header">
							Ranking de productos
							<span v-if="loadingProducts" class="float-right">
								<div class="spinner-border spinner-border-sm" role="status">
									<span class="sr-only">cargando...</span>
								</div>
								cargando...
							</span>
							<span class="float-right" v-else>
								{{ (onlyConfirmed == -1) ? 'Todas' : 'Confirmadas' }}
							</span>
						</div>
						<div class="card-body">
							<table class="table table-sm table-hover table-bordered">
								<thead>
									<tr>
										<th class="text-center">#</th>
										<th class="text-center">Código</th>
										<th class="text-center">Producto</th>
										<th class="text-center">Cantidad</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in listProducts" :key="index">
										<td class="text-center">{{ index + 1 }}</td>
										<td>{{ item.id }}</td>
										<td>{{ item.name }}</td>
										<td class="text-right">{{ methodFormatNumber(item.quantity_) }}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
				<div class="col-md-6 col-12">
					<div class="card">
						<div class="card-header">
							Ranking de Administracion Eclesiastica
							<span v-if="loadingEntities" class="float-right">
								<div class="spinner-border spinner-border-sm" role="status">
									<span class="sr-only">cargando...</span>
								</div>
								cargando...
							</span>
							<span class="float-right" v-else>
								{{ (onlyConfirmed == -1) ? 'Todas' : 'Confirmadas' }}
							</span>
						</div>
						<div class="card-body">
							<table class="table table-sm table-hover table-bordered">
								<thead>
									<tr>
										<th class="text-center">#</th>
										<th class="text-center">Campo Misionero</th>
										<th class="text-center">Total</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in listEntities" :key="index">
										<td class="text-center">{{ (index + 1) }}</td>
										<td>{{ item.name }}</td>
										<td class="text-right">{{ methodFormatNumber(item.total_) }}</td>
									</tr>
								</tbody>
							</table>
							<br>
						</div>
					</div>
					<div class="card">
						<div class="card-header">
							Ranking de Iglesias
							<input v-model="searchChurch" class="form-control-sm" type="text"
								v-on:keyup.enter="getChurchsLocal(1)">
							<span v-if="loadingChurchs" class="float-right">
								<div class="spinner-border spinner-border-sm" role="status">
									<span class="sr-only">cargando...</span>
								</div>
								cargando...
							</span>
							<span class="float-right" v-else>
								{{ (onlyConfirmed == -1) ? 'Todas' : 'Confirmadas' }}
							</span>
						</div>
						<div class="card-body">
							<table class="table table-sm table-hover table-bordered">
								<thead>
									<tr>
										<th class="text-center">#</th>
										<th class="text-center">Iglesia</th>
										<th class="text-center">Campo</th>
										<th class="text-center">Total</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in listChurchs" :key="index">
										<td class="text-center">{{ (index + 1) + ((pageChurchs - 1) * qRowsChurchs) }}
										</td>
										<td>{{ item.name }}</td>
										<td>{{ item.entity.synthetic }}</td>
										<td class="text-right">{{ methodFormatNumber(item.total) }}</td>
										<td class="text-right">
											<router-link :to="'/statistic/subscription/' + year + '/church/' + item.id"
												class="small-box-footer" title="Suscripciones"><i
													class="far fa-eye pointer text-info"></i></router-link>
										</td>
									</tr>
								</tbody>
							</table>
							<br>
							<pagination :pagination="paginationChurchs" @getAllList="getChurchsLocal"></pagination>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'

import Pagination from '@/components/Pagination.vue'
export default {
	name: 'Subscription',
	mixins: [axiosAction, errors, mixin],
	props: ['year', 'id'],
	data() {
		return {
			totals: {
				total: 0,
				confirmed: 0,
				paymentAmount: 0,
				churchExists: 0,
				orders: [],
				ordersPotentials: []
			},
			listProducts: [],
			listChurchs: [],
			listEntities: [],
			paginationChurchs: [],
			onlyMovement: true,
			loadingProducts: false,
			loadingChurchs: false,
			loadingEntities: false,
			loadingTotals: false,
			searchChurch: '',
			pageChurchs: 1,
			qRowsChurchs: 10,
			onlyConfirmed: -1
		}
	},
	computed: {
		totalPaidPercentage() {
			return Math.round((this.totals.confirmed * 100) / this.totals.total)
		},
		url() {
			return this.apiBackend + 'statistic/subscription/'
		},
		totalsSubscription() {
			let ob = {
				created: { quantity: 0, total: 0 },
				confirm: { quantity: 0, total: 0 },
			}
			this.totals.orders.forEach(o => {
				if (parseInt(o.status_id) == 30) {
					ob.created.quantity += parseInt(o.quantity)
					ob.created.total += parseInt(o.total)
				} else if (parseInt(o.status_id) == 31) {
					ob.confirm.quantity += parseInt(o.quantity)
					ob.confirm.total += parseInt(o.total)
				}
			})
			return ob
		},
		totalsSubscriptionPotentials() {
			let ob = {
				created: { quantity: 0, total: 0 },
				confirm: { quantity: 0, total: 0 },
			}
			this.totals.ordersPotentials.forEach(o => {
				if (parseInt(o.status_id) == 30) {
					ob.created.quantity += parseInt(o.quantity)
					ob.created.total += parseInt(o.total)
				} else if (parseInt(o.status_id) == 31) {
					ob.confirm.quantity += parseInt(o.quantity)
					ob.confirm.total += parseInt(o.total)
				}
			})
			return ob
		}
	},
	methods: {
		initModuleLocal() {
			this.setTitleModule('Estadisticas de suscripción')
			this.setSubTitleModule('(' + this.year + ')')
			setTimeout(() => {
				this.getAll()
			}, 10);
		},
		setOnlyPaid(value) {
			this.onlyConfirmed = value
			this.getChurchsLocal()
			this.getEntitiesLocal()
			this.getProductsLocal()
		},
		getAll() {
			this.searchChurch = ''
			this.getTotalSubscriptionLocal()
		},
		getTotalSubscriptionLocal() {
			this.loadingTotals = true
			let url = this.url + this.year
			this.axiosActionIS(url, 'GET', 'getTotalSubscriptionLocalResult')
		},
		getTotalSubscriptionLocalResult(response) {
			if (response.data.success == true) {
				this.totals = response.data.data
				this.setOnlyPaid(-1)
			}
			this.loadingTotals = false
		},
		getEntitiesLocal() {
			this.listEntities = []
			this.loadingEntities = true
			let param = '?statusId=' + this.onlyConfirmed
			let url = this.url + this.year + '/entities' + param
			this.axiosActionIS(url, 'GET', 'getEntitiesLocalResult')
		},
		getEntitiesLocalResult(response) {
			if (response.data.success == true) {
				this.listEntities = response.data.data
			}
			this.loadingEntities = false
		},
		getProductsLocal() {
			this.listProducts = []
			this.loadingProducts = true
			let param = '?statusId=' + this.onlyConfirmed
			let url = this.url + this.year + '/products' + param
			this.axiosActionIS(url, 'GET', 'getProductsLocalResult')
		},
		getProductsLocalResult(response) {
			if (response.data.success == true) {
				this.listProducts = response.data.data
			}
			this.loadingProducts = false
		},
		getChurchsLocal(page = 1) {
			this.pageChurchs = page
			this.listChurchs = []
			this.paginationChurchs = []
			this.loadingChurchs = true
			let param = '?onlyMovement=' + this.onlyMovement + '&page=' + page + '&search=' + this.searchChurch + '&statusId=' + this.onlyConfirmed
			let url = this.url + this.year + '/churchs' + param
			this.axiosActionIS(url, 'GET', 'getChurchsLocalResult')
		},
		getChurchsLocalResult(response) {
			if (response.data.success == true) {
				this.listChurchs = response.data.data
				this.paginationChurchs = response.data.paginate
			}
			this.loadingChurchs = false
		},
		resultAxiosLocal(responseLocal, response) {
			this.$emit('hideLockScreen')
			switch (responseLocal) {
				case 'getChurchsLocalResult': this.getChurchsLocalResult(response); break;
				case 'getEntitiesLocalResult': this.getEntitiesLocalResult(response); break;
				case 'getProductsLocalResult': this.getProductsLocalResult(response); break;
				case 'getTotalSubscriptionLocalResult': this.getTotalSubscriptionLocalResult(response); break;
				default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
			}
		},
	},
	components: {
		'pagination': Pagination,
	},
	mounted() {
		this.initModule()
	}
}

</script>

<style scoped lang="scss">
.spinner {
	width: 16px;
	height: 16px;
}
</style>